import Content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import McIcon from '@CS/assets/Vector/mcIcon.svg?component';
import type { LangCopy } from '@CS/components/TranslationProvider/types';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

import {
  SurvivalContainer,
  SurvivalTitle,
  SurvivalDescription,
  SurvivalBalance,
  SurvivalPoints,
  SurvivalCancelButton
} from './SurvivalMode.styles';

type SurvivalModeProps = PopupProps & {
  onSubmit: () => void;
  onCancel: () => void;
  points: number;
  score?: number;
  price: number;
};

export const SurvivalMode = ({
  onSubmit,
  onCancel,
  onClose,
  points,
  price,
  ...props
}: SurvivalModeProps) => {
  const [visible, setVisible] = useState(true);

  const title = useTranslation(Content.title);
  const submit = useTranslation(Content.submit);
  const cancel = useTranslation(Content.cancel);
  const balance = useTranslation(Content.balance);

  const description = useTranslation(
    Content.description as unknown as LangCopy
  ) as unknown as (price: number) => string;

  const onSubmitClick = () => {
    setTimeout(onSubmit, FADE_DURATION);
    setVisible(false);
  };

  const onCancelClick = () => {
    setTimeout(onCancel, FADE_DURATION);
    setVisible(false);
  };

  return (
    <Popup
      customStyle={{ padding: 0 }}
      onClose={onClose}
      close={!visible}
      {...props}
      hideClose
    >
      <SurvivalContainer>
        <SurvivalTitle>{title}</SurvivalTitle>
        <SurvivalDescription>{description(price)}</SurvivalDescription>
        <SurvivalBalance>{balance}</SurvivalBalance>

        <SurvivalPoints>
          <McIcon />
          {points}
        </SurvivalPoints>

        <Button
          disabled={points < price}
          onClick={onSubmitClick}
          text={submit}
        />

        <SurvivalCancelButton onClick={onCancelClick} width="100%">
          {cancel}
        </SurvivalCancelButton>
      </SurvivalContainer>
    </Popup>
  );
};
